const apiFetch = async (url: string, options: RequestInit): Promise<unknown> => {
    let response: Response;

    try {
        response = await fetch(url, options);
    } catch (networkError: unknown) {
        const msg = networkError instanceof Error ? networkError.message : String(networkError);
        throw new Error(`Erreur réseau sur ${url} : ${msg}`);
    }

    if (!response.ok) {
        let detail = `HTTP ${response.status}`;
        try {
            const rawText = await response.text();
            if (rawText) {
                try {
                    const body = JSON.parse(rawText);
                    if (body?.detail) {
                        detail = typeof body.detail === 'string'
                            ? body.detail
                            : JSON.stringify(body.detail, null, 2);
                    }
                } catch {
                    detail = rawText;
                }
            }
        } catch {
            // keep generic HTTP status
        }
        throw new Error(detail);
    }

    return response.json();
};

export default apiFetch;
